import {makeAutoObservable} from 'mobx';

export enum LineHeight {
    S = 0.25,
    M = 0.375,
    L = 0.5,
}

export enum Size {
    S = 16,
    M = 24,
    L = 32,
}

export enum Font {
    Roboto = 1,
    LibreBaskerville = 2,
    Carlito = 3,
    TimesNewRoman = 4,
    EBGaramond = 5,
    NunitoSans = 6,
    CrimsonText = 7,
    IBMPlexMono = 8,
}

export const FONT_FAMILY_MAP: Record<Font, string> = {
    [Font.Roboto]: 'Roboto, Poppins, Open Sans, Proxima Nova, system-ui, sans-serif',
    [Font.LibreBaskerville]: '"Libre Baskerville", Georgia, "Times New Roman", serif',
    [Font.Carlito]: 'Carlito, Calibri, Arial, sans-serif',
    [Font.TimesNewRoman]: '"Times New Roman", Times, serif',
    [Font.EBGaramond]: '"EB Garamond", Garamond, "Times New Roman", serif',
    [Font.NunitoSans]: '"Nunito Sans", Nunito, system-ui, sans-serif',
    [Font.CrimsonText]: '"Crimson Text", Georgia, "Times New Roman", serif',
    [Font.IBMPlexMono]: '"IBM Plex Mono", Consolas, "Courier New", monospace',
};

export const FONT_OPTIONS = [
    {value: Font.Roboto, label: 'Roboto'},
    {value: Font.LibreBaskerville, label: 'Libre Baskerville'},
    {value: Font.Carlito, label: 'Carlito'},
    {value: Font.TimesNewRoman, label: 'Times New Roman'},
    {value: Font.EBGaramond, label: 'EB Garamond'},
    {value: Font.NunitoSans, label: 'Nunito Sans'},
    {value: Font.CrimsonText, label: 'Crimson Text'},
    {value: Font.IBMPlexMono, label: 'IBM Plex Mono'},
];

export type EPLine = {
    text: string;
    lineHeight: LineHeight;
    size: Size;
    bold: boolean;
    italic: boolean;
};

class EngravedPlateExtendedStore {
    public lines: EPLine[] = [];
    public fontFamily: string;

    constructor() {
        makeAutoObservable(this);
    }
}

export const engravedPlateExtendedStore = new EngravedPlateExtendedStore();
